import { useEffect, useState } from "react";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";

/* ICONS */

/* TOAST NOTIFICATION */
import { toast } from "react-toast";

/* ASSETS */
import Logo from "../../assets/images/logo.png";
import { HiMenuAlt1 } from "react-icons/hi";

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(null);

  /* GREETING */
  var greetingText = "";
  const today = new Date();
  const currentHours = today.getHours();

  if (currentHours < 12) {
    greetingText = "Good morning";
  } else if (currentHours < 18) {
    greetingText = "Good afternoon";
  } else {
    greetingText = "Good evening";
  }

  const handleLogout = () => {
    toast.warn("You have logged out of your account successfully.");
    navigate("/");
    localStorage.clear();
    setUserDetails(null);
  };

  useEffect(() => {
    // Get user details from localStorage
    const user = localStorage.getItem("user");
    if (user) {
      setUserDetails(JSON.parse(user));
    } else {
      navigate("/");
    }
  }, [navigate]);

  return (
    <section className="bg-white border border-authBorder px-5 py-2 w-full rounded-lg">
      <div className="flex items-center justify-between h-full">
        {/* LEFT */}
        <div className="flex items-center gap-3">
          <img src={Logo} alt="Logo" className="h-10 w-auto" />
          <h2 className="text-lg font-ibm-semibold text-black hidden xl:block lg:block">
            {greetingText}, {userDetails?.firstName} {userDetails?.lastName}
          </h2>

          <button
            onClick={toggleSidebar}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors md:hidden"
          >
            <HiMenuAlt1 className="w-6 h-6 text-black " />
          </button>
        </div>

        {/* RIGHT */}
        <div className="flex items-center gap-3">
          <Menu
            animate={{
              mount: { y: 0 },
              unmount: { y: 25 },
            }}
            allowHover
          >
            <MenuHandler>
              <div className="flex items-center gap-2 hover:outline-none cursor-pointer">
                <div className="w-10 h-10 bg-black rounded-full flex items-center justify-center">
                  <p className="text-sm font-ibm-semibold text-white leading-none">
                    {userDetails?.firstName?.[0]}
                    {userDetails?.lastName?.[0]}
                  </p>
                </div>
                <div>
                  <h2 className="text-base font-ibm-semibold text-black dark:text-white">
                    {userDetails?.firstName} {userDetails?.lastName}
                  </h2>
                  <p className="text-sm font-ibm-regular text-greyText dark:text-lightGreyText">
                    {userDetails?.designation === "OFFICE-BEARER"
                      ? "Office bearer"
                      : userDetails?.designation === "JURY"
                      ? "Jury"
                      : "Super admin"}
                  </p>
                </div>
              </div>
            </MenuHandler>
            <MenuList className="p-0 mt-1 bg-white dark:bg-darkSidebar border dark:border-darkBorder">
              <MenuItem
                onClick={handleLogout}
                className="hover:bg-logoYellow hover:bg-opacity-20 active:bg-buttonColor active:bg-opacity-20 focus:bg-buttonColor focus:bg-opacity-20 rounded-none py-4"
              >
                <p className="text-sm font-ibm-regular text-[#4B4B4B] dark:text-white">
                  Logout
                </p>
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
      </div>
    </section>
  );
};

export default Header;
